import { APIViewpointAttributes } from '@ardoq/api-types';
import { isPresentationMode } from 'env';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';
import { toRenderedViewpointViewSettings } from 'tabview/flexibleBlockDiagram/renderedViewpointViewSettings';
import { withDefaultsForOmittedSettings } from 'appLayout/ardoqStudio/viewpointViewSettings';

export const applyViewpointViewSettings = (
  traversal: Pick<APIViewpointAttributes, 'viewSettings' | 'viewName'> | null
) => {
  const storedSettings = traversal?.viewSettings?.[traversal.viewName];

  if (!storedSettings) {
    return;
  }

  // Hydrate the settings slice of the view actually rendered. Block Diagram ↔
  // Flexible Block Diagram needs no conversion — FBD settings are a superset
  // (ARD-33247) — so the stored settings pass through unchanged.
  const { viewId, settings } = toRenderedViewpointViewSettings(
    traversal.viewName,
    storedSettings
  );
  onViewSettingsUpdate(
    viewId,
    withDefaultsForOmittedSettings({
      storedViewId: traversal.viewName,
      renderedViewId: viewId,
      storedSettings: settings,
    }),
    !isPresentationMode()
  );
};
